import _, {
  every,
  filter,
  isArray,
  isEmpty,
  isNil,
  map,
  mapKeys,
  omitBy,
} from "lodash";
import moment from "moment";
import numeral from "numeral";
import { toString } from "@telerik/kendo-intl";

const {
  REACT_APP_NUMERAL_FORMAT,
  REACT_APP_DATE_FORMAT,
  REACT_APP_TIME_FORMAT,
} = process.env;

//TODO: ADD Symbol functionality
//initialize formatting
numeral.defaultFormat(REACT_APP_NUMERAL_FORMAT);

export function formatNumber(value) {
  let strFormattedAmount = numeral(value).format();
  return strFormattedAmount;
}

export function convertDateToDisplay(strDate) {
  const convertDate = moment(
    strDate,
    `${REACT_APP_DATE_FORMAT} ${REACT_APP_TIME_FORMAT}`
  ).toDate();
  return moment(convertDate).format(REACT_APP_DATE_FORMAT);
}

export function convertDateTimeToDisplay(strDate, withTime = true) {
  const convertDate = moment(
    strDate,
    `${REACT_APP_DATE_FORMAT} ${REACT_APP_TIME_FORMAT}`
  ).toDate();
  if (withTime)
    return moment(convertDate).format(
      `${REACT_APP_DATE_FORMAT} ${REACT_APP_TIME_FORMAT}`
    );
  else return moment(convertDate).format(`${REACT_APP_DATE_FORMAT}`);
}

//helper to check permission logic
// export function hasPermission(cPermissionId, permissions) {
//   //get the first layer of permission
//   const findPermissionObj = _.find(permissions, { id: cPermissionId });
//   // console.log('findPermissionObj', rPermissionId, findPermissionObj)
//   if (findPermissionObj) {
//     return findPermissionObj.state === 1;
//   } else {
//     //do the loop here for the second layer
//     const findParentObj = _.find(permissions, {
//       children: [
//         {
//           id: cPermissionId,
//         },
//       ],
//     });

//     // console.log("findPermissionChildObj", findParentObj)

//     if (findParentObj) {
//       const { children } = findParentObj;
//       const childObj = _.find(children, { id: cPermissionId });

//       return childObj.state === 1;
//     }
//   }

//   return false;
// }

export function hasPermission(cPermissionId, permissions) {
  function findPermission(permissionList, permissionId) {
    for (const permission of permissionList) {
      if (permission.id === permissionId) {
        return permission.state === 1;
      }
      if (permission.children) {
        const result = findPermission(permission.children, permissionId);
        if (result !== null) {
          return result;
        }
      }
    }
    return null;
  }

  return findPermission(permissions, cPermissionId) === true;
}

const isArrayOfDates = (arr) =>
  arr.every(
    (item) =>
      (typeof item === "object" || typeof item === "string") &&
      isValidDate(item)
  );
const isArrayOfStrings = (arr) => arr.every((item) => typeof item === "string");
const isArrayOfNumbers = (arr) => arr.every((item) => typeof item === "number");
const isArrayOfBooleans = (arr) =>
  arr.every((item) => typeof item === "boolean");

export function convertDataToJsonPayload(data) {
  let queryParamObj = {};
  if (data == null) return queryParamObj;
  for (const arr of Object.entries(data)) {
    if (!isEmpty(arr[1]) && isArray(arr[1])) {
      queryParamObj = {
        ...queryParamObj,
        ...(isArrayOfStrings(arr[1]) && {
          [arr[0]]: '{"$in":' + JSON.stringify(arr[1]) + "}",
        }),
        ...(isArrayOfDates(arr[1]) && {
          [arr[0]]: map(arr[1], (v) => moment(v).format("YYYY-MM-DD")).join(
            ","
          ),
        }),
        ...(isArrayOfNumbers(arr[1]) && {
          [arr[0]]: '{"$in":' + JSON.stringify(arr[1]) + "}",
        }),
        ...(isArrayOfBooleans(arr[1]) && {
          [arr[0]]: '{"$in":' + JSON.stringify(arr[1]) + "}",
        }),
      };
    } else {
      queryParamObj = {
        ...queryParamObj,
        [arr[0]]: arr[1],
      };
    }
  }

  return omitBy(queryParamObj, (value) => isNil(value) || value === "");
}

export function isNaNValue(value, defaultValue) {
  return isNaN(value) ? defaultValue : value;
}

export function isEmptyValue(value) {
  return (
    value === undefined ||
    value === null ||
    value === NaN ||
    (typeof value === "object" && !isValidDate(value)) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}

export function areAllEmptyValues(obj) {
  return every(obj, (value) => {
    return (
      (Array.isArray(value) && value.length === 0) ||
      value === undefined ||
      value === null ||
      (typeof value === "string" && value.trim() === "")
    );
  });
}

export function isValidDate(date) {
  // Check if the date is an instance of Date
  if (date instanceof Date || typeof date === "string") {
    // Check if the date is valid
    let dateFormat = "DD-MM-YYYY";
    let isValid = moment(
      moment(date).format(dateFormat),
      dateFormat,
      true
    ).isValid();

    return isValid;
  }

  return false;
}

export function concatArray(arr = []) {
  if (arr.length === 0) return "";
  if (arr.length === 1) return arr[0];

  let arr1 = arr.slice(0, arr.length - 1);
  let arrLast = arr.slice(arr.length - 1, arr.length);

  return `${arr1.join(", ")} and ${arrLast[0]}`;
}

export function convertToTitleCase(str) {
  if (!str) {
    return "";
  }
  return str.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
}

export function keysToLowercase(obj) {
  return mapKeys(obj, (value, key) => _.toLower(key));
}

export function formatNumberValue(
  number = 0,
  options = { maxDecimal: undefined }
) {
  // debugger;
  if (options.maxDecimal) {
    if (
      number.toString().includes(".") &&
      number.toString().split(".")[1].length > options.maxDecimal
    ) {
      return toFixedWithoutZeros(number, options.maxDecimal);
    }
  }

  return toFixedWithoutZeros(number);
}

export function removeTrailingZeros(num) {
  // Convert the number to a string
  let str = num.toString();

  // Use regex to remove trailing zeros and the decimal point if it's at the end
  str = str.replace(/(\.\d*[^0])0+$|\.0+$/, "$1");

  return str;
}

export const toFixedWithoutZeros = (num, precision) => {
  if (!precision) return formatNumberWithCommas(num);

  if (typeof num === "string")
    return `${formatNumberWithCommas(
      Number.parseFloat(parseFloat(num).toFixed(precision))
    )}`;

  return `${formatNumberWithCommas(Number.parseFloat(num.toFixed(precision)))}`;
};

function formatNumberWithCommas(num) {
  // Convert the number to a string and separate the integer and decimal parts
  let [integerPart, decimalPart] = num.toString().split(".");

  // Use regex to add commas as thousand separators to the integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // If there's a decimal part, return the formatted integer part with the decimal part
  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
}

export const toProperCase = (str) => {
  return str.replace(
    /\w\S*/g,
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );
};

export const getLetterByIndex = (index) => {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const alphabetArray = Array.from(alphabet);

  return alphabetArray[index];
};

export function isValueInRange(value, min, max) {
  const lowerBound = Math.min(min, max);
  const upperBound = Math.max(min, max);
  return value >= lowerBound && value <= upperBound;
}

export const addValueIfNotExists = (arr, values) => {
  const valuesNotExist = filter(values, (v) => !arr.includes(v));
  if (valuesNotExist) {
    return [...arr, ...valuesNotExist];
  }
  return arr; // Return original array if number already exists
};

export function formatPhoneNumber(input) {
  // Remove all non-numeric characters
  const cleaned = ("" + input).replace(/\D/g, "");

  // If the input is not of valid length after cleaning, return an error or a default message
  if (cleaned.length < 9) {
    return "Invalid phone number";
  }

  // Determine if input starts with '971' and format accordingly
  if (cleaned.startsWith("971")) {
    // Removing country code for local formatting
    const localNumber = cleaned.slice(3);
    // Format according to UAE standards
    return `+971 ${localNumber.slice(0, 2)} ${localNumber.slice(
      2,
      5
    )} ${localNumber.slice(5)}`;
  }

  // Handle the case for the local numbers starting with 0 (like 050, 055, etc.)
  if (cleaned.startsWith("0")) {
    const localNumber = cleaned.slice(1); // Strip the leading 0
    return `+971 ${localNumber.slice(0, 2)} ${localNumber.slice(
      2,
      5
    )} ${localNumber.slice(5)}`;
  }

  // If the number is in a different format or missing a country code
  return `+971 ${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(
    5
  )}`;
}
